import { render } from "./ResultPopup.vue?vue&type=template&id=53633ba2&scoped=true"
import script from "./ResultPopup.vue?vue&type=script&lang=js"
export * from "./ResultPopup.vue?vue&type=script&lang=js"

import "./ResultPopup.vue?vue&type=style&index=0&id=53633ba2&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53633ba2"]])

export default __exports__